/*
Extension of the Backbone Collection to work better with Django-Tastypie

Based on http://paltman.com/2012/04/30/integration-backbonejs-tastypie/
*/
import _ from 'underscore';
import Backbone from 'backbone_fetch_cache';


export default Backbone.Collection.extend({
  parse: function (response) {
    this.recent_meta = response.meta || {};
    return response.objects || response;
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/orcas-core/core/static/js/core/collections/tastypie.js
// module id = 143
// module chunks = 0